<template>
	<section class="content">
		<div class="row">
			<div class="col-md-12">
				<div class="box box-primary">
					<div class="box-header with-border">
						<h3 class="box-title">
							<b>Novo Subgrupo do Contrato</b>
						</h3>

					</div>

					<div class="box-body">
						<div class="row">
							<div class="col-md-9">
								<div class="form-group">
									<label :class="{'erro-validacao': showTextDangerSubgrupo}">Subgrupo</label>
									<select-subgrupo :show-text-danger-subgrupo="showTextDangerSubgrupo" @setSubgrupoSelecionado="(subgrupoSelecionado)=>{setSubgrupoSelecionado(subgrupoSelecionado)}" :nomeSubgrupo="dados.subgrupo.nome"></select-subgrupo>
								</div>
							</div>

							<div class="col-md-3" :class="{'has-error': showTextDangerLimite}">
								<div class="form-group">
									<label :class="{'erro-validacao': showTextDangerLimite}">Limite Financeiro (R$)</label>
									<money class="form-control" v-model="dados.limite.valor" v-bind="money" autofocus></money>
								</div>
							</div>
						</div>
					</div>
					<div class="box-footer">
						<div class="row">
							<div class="col-md-12">
								<button
									@click="salvar()"
									class="btn btn-primary pull-right"
									type="button"
								><i class="fa fa-save"></i> Salvar</button>
								<button
									class="btn btn-default pull-left"
									@click="$router.go(-1)"
								><i class="fa fa-close"></i> Cancelar</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

	</section>
</template>
<script>
	import axios from "axios"; // Cliente para requisição http
	import selectSubgrupo from "../../cadastros/procedimentos/subgrupos/selectSubgrupo";
	import { Money } from 'v-money';

	export default {
		props:['contratoId'],
		filters: {},
		data: () => ({
			showTextDangerSubgrupo: false,
			showTextDangerLimite: false,

			procedimentoSelecionado: {},
			money: {
				decimal: ',',
				thousands: '.',
				prefix: 'R$ ',
				precision: 2,
				masked: false
			},
			dados: {
				limite: {
					valor: 0
				},
				procedimento_subgrupo_id: null,
				distribuicao_contrato_id: null,
				subgrupo:{
					nome: null
				}
			}

		}),
		mounted() {

			if (this.$route.params.contrato_subgrupo_id) {
				this.getById(this.$route.params.contrato_subgrupo_id);
				this.atualizacao = true;
			} else {
				this.dados.distribuicao_contrato_id = this.$route.params.contrato_id;
			}

		},
		methods: {
			salvar() {
				if (this.validar()) {
					if (this.atualizacao) {
						axios.post(
							`${this.$store.state.serverURI}/api/distribuicao/contratos/updateContratoSubgrupo/${this.dados.id}`,
							this.dados,
							this.$store.getters.getHeaderAuth
						)
							.then(response => {
								this.$swal({
									type: "success",
									title: "Subgrupo atualizado com sucesso!",
									showConfirmButton: false,
									timer: 1500
								});
								this.$router.push(`/distribuicoes/contratos/subgrupos/${this.dados.distribuicao_contrato_id}`);
							})
							.catch(error => {
								var erros = error.response.data.message + " ";
								for (var erro of Object.values(error.response.data.errors)) {
									erros += erro + " \n";
								}
								this.$swal({
									type: "error",
									title: "Houve uma falha!",
									text: erros
								});
							});
					} else {
						axios.post(
							`${this.$store.state.serverURI}/api/distribuicao/contratos/createContratoSubgrupo`,
							this.dados,
							this.$store.getters.getHeaderAuth
						)
							.then(response => {

								if (response.data.status) {
									this.$swal({
										type: "success",
										title: response.data.msg,
										showConfirmButton: false,
										timer: 1500
									});
									this.$router.push(`/distribuicoes/contratos/subgrupos/${this.dados.distribuicao_contrato_id}`);
								} else {
									this.$swal({
										type: "error",
										title: response.data.titulo_msg,
										text: response.data.msg,
										showConfirmButton: true,
									}).then(() => {
										this.$router.push(`/distribuicoes/contratos/subgrupos/${this.dados.distribuicao_contrato_id}`);
									});
								}
							})
							.catch(error => {
								var erros = error.response.data.message + " ";
								for (var erro of Object.values(error.response.data.errors)) {
									erros += erro + " \n";
								}
								this.$swal({
									type: "error",
									title: "Houve uma falha!",
									text: erros
								});
							});
					}
				} else {
					this.$swal({
						type: "error",
						title: "Informações pendentes",
						text: "Preencha corretamente os campos destacados em vermelho!",
					});
				}
			},

			getById(contratoSubgrupoId) {

				this.$store.commit('TOGGLE_LOADING');
				axios.get(`${this.$store.state.serverURI}/api/distribuicao/contratos/getContratoSubgrupoById/${contratoSubgrupoId}`, this.$store.getters.getHeaderAuth).then(response => {

					this.dados = response.data;

					this.$store.commit('TOGGLE_LOADING');

				}).catch((error) => {
					console.log(error)
				});
			},

			setSubgrupoSelecionado(subgrupoSelecionado) {
				this.subgrupoSelecionado = subgrupoSelecionado;
				this.dados.procedimento_subgrupo_id = subgrupoSelecionado.id;
			},
			validar() {

				let validou = true;
				if (this.dados.procedimento_subgrupo_id === null) {
					this.showTextDangerSubgrupo = true;
					validou = false;
				}
				if (this.dados.limite.valor === null) {
					this.showTextDangerLimite = true;
					validou = false;
				}
				return validou;
			},
		},
		watch: {

		},
		components: {
			selectSubgrupo,
			Money
		}
	};
</script>
<style>
</style>



// WEBPACK FOOTER //
// contratoSubgrupoForm.vue?f14af0a6